<section class="assignment-card">
  <div class="assignment-card__header">
    <div class="assignment-card__cell assignment-card__cell--name">
      Notification
      <tp-icon
        class="assignment-card__tip-icon m-l-1"
        [tpTooltip]="tooltips.notifications"
        name="icons/help"
      ></tp-icon>
    </div>

    <div class="assignment-card__cell">Email</div>
    <div *ngIf="showPushNotifications" class="assignment-card__cell">Push Notifications</div>
  </div>

  <div class="assignment-body">
    <div *ngFor="let notification of notifications; let index = index" class="assignment-card__row">
      <div class="assignment-card__cell assignment-card__cell--name">
        {{ notification.label }}

        <tp-icon
          *ngIf="tooltips.notificationItems[notification.name]"
          class="assignment-card__tip-icon m-l-1"
          [tpTooltip]="tooltips.notificationItems[notification.name]"
          name="icons/tooltip-question"
        ></tp-icon>
      </div>

      <!-- email toggle -->
      <div class="assignment-card__cell">
        <mat-slide-toggle
          [disabled]="notification.name === 'schedule'"
          (change)="notificationChange($event, index, 'email')"
          [checked]="notification.email"
        ></mat-slide-toggle>
      </div>

      <!-- text toggle -->
      <div *ngIf="showPushNotifications" class="assignment-card__cell">
        <mat-slide-toggle
          (change)="notificationChange($event, index, 'text')"
          [checked]="notification.text"
        ></mat-slide-toggle>
      </div>
    </div>
  </div>
</section>
